// extracted by mini-css-extract-plugin
export default {"img_thumbnail":"Plan_img_thumbnail__Tbv4b"};